export const ROOT = "/";
export const AUTH_PREFIX_PATH = "/auth";
export const PAGES_PREFIX_PATH = "/pages";
